import "react-toastify/dist/ReactToastify.css";
import Navbar from "./Navbar";
import Mercury from "./Mercury";
import Venus from "./Venus";
import Earth from "./Earth";
import Mars from "./Mars";
import Jupiter from "./Jupiter";
import FadeInSection from "./FadeIn";
import HeroSection from "./Hero";
import Footer from "./Footer";

const MainScene = () => {

  return (
    <div style={styles.container}>
      <Navbar />
      <div style={styles.mainContent} id='home'>
                  <HeroSection/>
      </div>
      <div style={styles.sectionsContainer}>
  <FadeInSection id="mercury">
    <Mercury />
  </FadeInSection>
  <FadeInSection id="earth">
    <Earth />
  </FadeInSection>
  <FadeInSection id="venus">
    <Venus />
  </FadeInSection>
  <FadeInSection id="mars">
    <Mars />
  </FadeInSection>
  <FadeInSection id="jupiter">
    <Jupiter />
  </FadeInSection>
</div>
<Footer/>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    backgroundColor:'black',
    backgroundSize: "cover",
    backgroundAttachment: "fixed",
    color: "white",
    overflowY: "auto",
    scrollBehavior: "smooth", // Smooth scrolling
  },
  mainContent: {
    display: "flex",
    alignItems: "center",
    flex: 1,
    marginTop:'45px',
    marginLeft:'30px',
    marginRight:'30px',
  },
  section: {
    minHeight: "100vh", // Full screen for each section
    padding: "50px",
    color: "white",
    textAlign: "center",
    backgroundColor: "rgba(0, 0, 0, 0.6)", // Semi-transparent background for each section
  },
  sectionHeading: {
    fontSize: "32px",
    fontWeight: "bold",
  },
  sectionContent: {
    fontSize: "18px",
    lineHeight: "1.6",
  },
  sectionsContainer: {
  width: "100%",
  paddingTop: "40px",
},

};

export default MainScene;
